import { Autoplay, Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';

const UserFeedbackSection = () => {
  return (
    <div className='feedback'>
      <div className='container mx-auto flex flex-col items-center pb-12'>
        <div className='feedback-title'></div>
        <div className='feedback-wrapper w-full relative'>
          <div className='feedback-sliders swiper'>
            <div className='swiper-wrapper'>
              <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                slidesPerView={2}
                spaceBetween={4}
                loop
                autoplay={{ delay: 5000 }}
                navigation={{
                  nextEl: '.feedback-button-next',
                  prevEl: '.feedback-button-prev',
                }}
                breakpoints={{
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 12,
                  },
                }}
              >
                {FEEDBACK_ARR.map((feedback, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <FeedbackItem
                        key={index}
                        avatarCharacter={feedback.avatarCharacter}
                        name={feedback.name}
                        desc={feedback.desc}
                        starRate={feedback.starRate}
                      />
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          </div>
          <div className='feedback-button-nav feedback-button-prev swiper-button-prev'></div>
          <div className='feedback-button-nav feedback-button-next swiper-button-next'></div>
        </div>
      </div>
    </div>
  );
};

export default UserFeedbackSection;

interface Props {
  avatarCharacter: string;
  name: string;
  desc: string;
  starRate: number;
}

const FeedbackItem = ({ avatarCharacter, name, desc, starRate }: Props) => {
  //
  const oddStar = Math.floor(starRate / 1);
  const eventStar = starRate % 1;
  const starArr = [];
  let i;
  for (i = 0; i < oddStar - 1; i++) {
    starArr.push(<div key={i} className='star'></div>);
  }
  if (eventStar > 0) {
    starArr.push(<div key={i} className='star star-half'></div>);
  }

  return (
    <div className='swiper-slide feedback-item'>
      <div className='item-header'>
        <div className='item-avatar'>{avatarCharacter}</div>
        <div className='item-name'>
          <div className='item-title'>{name}</div>
        </div>
      </div>
      <div className='item-content'>
        <div className='item-starts'>{starArr}</div>
        <div className='item-desc'>{desc}</div>
      </div>
    </div>
  );
};

const FEEDBACK_ARR = [
  {
    key: 0,
    avatarCharacter: 'T',
    name: 'Tăng Thế Anh',
    starRate: 5,
    desc: 'Đối với các game mình từng chơi thì game này ngon nhất, các bạn chăm sóc khách hàng cũng rất nhanh nhẹn - cho 5 sao',
  },
  {
    key: 1,
    avatarCharacter: 'Đ',
    name: 'Đỗ Hoàng Phong',
    starRate: 4.5,
    desc: 'Game nhẹ, k hao pin, mượt, chơi trực tiếp tiện lợi, đối với mình rất ổn',
  },
  {
    key: 2,
    avatarCharacter: 'T',
    name: 'Thân Gia Hải',
    starRate: 5,
    desc: ' ai yêu thích thể loại quan đấu hay cung đấu như mình thì đừg bỏ qua con vương lão gia này',
  },
  {
    key: 3,
    avatarCharacter: 'C',
    name: 'Chu Ái Mẫn',
    starRate: 4.5,
    desc: ' Thích nhất việc liên kết với Zalo, đăng nhập an toàn nhanh khoẻ không rườm rà khỏi lo nghĩ',
  },
  {
    key: 4,
    avatarCharacter: 'L',
    name: 'La Gia Kiến',
    starRate: 5,
    desc: 'Gamplay ổn, dịch vụ khách hàng tốt, đồ hoạ mỹ nhân đẹp nói chung nên chơi',
  },
  {
    key: 5,
    avatarCharacter: 'H',
    name: 'Hoàng Gia Lão',
    starRate: 5,
    desc: 'Xài 3 thiết bị 1 xiaomi, 1 ios, 1 laptop, đúng là đa nền tảng đa thiết bị, cày mọi lúc mọi nơi chỉ cần Zalo. Đây cũng là điều cá nhân mình thích nhất',
  },
  {
    key: 6,
    avatarCharacter: 'T',
    name: 'Triệu Âu Duẫn',
    starRate: 4,
    desc: 'Ưu điểm: Mượt, nhanh, liên kết zalo, đông, đẹp. Nhược điểm: Chăm sóc khách hàng đôi lúc chậm nhưng vẫn được giải quyết ổn',
  },
  {
    key: 7,
    avatarCharacter: 'H',
    name: 'Hoàng Vô Thường',
    starRate: 5,
    desc: 'Vương Lão Gia chính xác là game mà nhiều người mong muốn vừa hay vừa tiện lợi. Ưng nhất là liên kết với Zalo & dàn mỹ nữ. CSKH cũng tốt',
  },
  {
    key: 8,
    avatarCharacter: 'D',
    name: 'Dương Châu Minh',
    starRate: 5,
    desc: 'Cảm ơn Zagoo đã mang đến cho mọi người 1 con game quan đấu tuyệt vời',
  },
  {
    key: 9,
    avatarCharacter: 'H',
    name: 'Hoàng Minh Khoa',
    starRate: 4.5,
    desc: 'Các game mình chơi có bộ phận cskh chưa được tốt nhưng game Vương Lão Gia lại khắc phục được điều này, mọi người nên trải nghiệm',
  },
];
